// extracted by mini-css-extract-plugin
export default {"overlayArea":"overlayArea-Q6tN7","scroll":"scroll-Y0EU1","accountPanelV2":"accountPanelV2-XU578","links":"links-xR5q5"};